import { Tooltip } from "primereact/tooltip";
import { FiEdit2, FiZap, FiUploadCloud } from "react-icons/fi";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import useSetPickOfTheWeek from "api/BookResource/useSetPickOfTheWeek";
import useSetRecommended from "api/BookResource/useSetRecommended";
import useSetSpotlightedBooks from "api/BookResource/useSetSpotlightedBooks";
import DeleteBook from "./BookCard/DeleteBook";

const BookActionsColumn = ({ book, isAdmin, onEdit, onUploadFiles }) => {
	const { mutateAsync: mutatePickOfTheWeek, isLoading: isSettingPickOfTheWeek } =
		useSetPickOfTheWeek(book?.id);

	const { mutateAsync: mutateSetRecommended, isLoading: isSettingRecommended } = useSetRecommended(
		book?.id,
	);

	const { mutateAsync: mutateSetSpotlight, isLoading: isSettingSpotlight } =
		useSetSpotlightedBooks();

	const setAsPickofTheWeek = async (e) => {
		e.stopPropagation();
		await mutatePickOfTheWeek();
	};

	const setAsRecommended = async (e) => {
		e.stopPropagation();
		await mutateSetRecommended();
	};

	const toggleSpotlight = async (e) => {
		e.stopPropagation();
		try {
			await mutateSetSpotlight({ bookId: book?.id });
		} catch (error) {
			console.error("Failed to toggle spotlight:", error);
		}
	};

	return (
		<div className="flex items-center justify-center gap-2 p-1">
			<Tooltip target=".action-btn" position="top" />

			<div className="flex items-center gap-1.5 pr-2 border-r border-gray-100">
				<button
					type="button"
					onClick={(e) => {
						e.stopPropagation();
						onEdit?.();
					}}
					className="action-btn w-9 h-9 rounded-xl flex items-center justify-center bg-white text-akgreener hover:bg-akgreen hover:text-white transition-all duration-300 border border-gray-100 hover:border-akgreen shadow-sm hover:shadow-md active:scale-90"
					aria-label={`Edit ${book?.title || "book"}`}
                    data-pr-tooltip="Edit book details"
				>
					<FiEdit2 size={16} />
				</button>

				<button
					type="button"
					onClick={(e) => {
						e.stopPropagation();
						onUploadFiles?.();
					}}
					className="action-btn w-9 h-9 rounded-xl flex items-center justify-center bg-white text-akgreener hover:bg-akgreen hover:text-white transition-all duration-300 border border-gray-100 hover:border-akgreen shadow-sm hover:shadow-md active:scale-90"
					aria-label={`Upload files for ${book?.title || "book"}`}
                    data-pr-tooltip="Upload book files"
				>
					<FiUploadCloud size={16} />
				</button>

				{isAdmin && <DeleteBook elementId={`delete-${book?.id}`} bookId={book?.id} />}
			</div>

			{isAdmin && (
				<div className="flex items-center gap-1.5 pl-0.5">
					{/* <button
						type="button"
						onClick={setAsPickofTheWeek}
						className={`action-btn w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md active:scale-90 border ${
							book?.pick_of_week
								? "bg-orange-500 text-white border-orange-500"
								: "bg-white text-gray-400 border-gray-100 hover:border-orange-400 hover:text-orange-500"
						}`}
						data-pr-tooltip={
							book?.pick_of_week ? "Remove from Pick of Week" : "Set as Pick of Week"
						}
					>
						{isSettingPickOfTheWeek ? (
							<AiOutlineLoading3Quarters size={16} className="animate-spin" />
						) : (
							<FiAward size={16} fill={book?.pick_of_week ? "currentColor" : "none"} />
						)}
					</button>

					<button
						type="button"
						onClick={setAsRecommended}
						className={`action-btn w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md active:scale-90 border ${
							book?.recommended
								? "bg-akgreenest text-white border-akgreenest"
								: "bg-white text-gray-400 border-gray-100 hover:border-akgreen hover:text-akgreener"
						}`}
						data-pr-tooltip={book?.recommended ? "Remove Recommendation" : "Recommend"}
					>
						{isSettingRecommended ? (
							<AiOutlineLoading3Quarters size={16} className="animate-spin" />
						) : (
							<FiStar size={16} fill={book?.recommended ? "currentColor" : "none"} />
						)}
					</button> */}

					<button
						type="button"
						onClick={toggleSpotlight}
						className={`action-btn w-9 h-9 rounded-xl flex items-center justify-center transition-all duration-300 shadow-sm hover:shadow-md active:scale-90 border ${
							book?.is_spotlighted
								? "bg-yellow-400 text-white border-yellow-400"
								: "bg-white text-gray-400 border-gray-100 hover:border-yellow-400 hover:text-yellow-500"
						}`}
						aria-label={`${book?.is_spotlighted ? "Remove" : "Add"} ${book?.title || "book"} ${book?.is_spotlighted ? "from" : "to"} spotlight`}
                        disabled={isSettingSpotlight}
                        data-pr-tooltip={book?.is_spotlighted ? "Remove from Spotlight" : "Add to Spotlight"}
					>
						{isSettingSpotlight ? (
							<AiOutlineLoading3Quarters size={16} className="animate-spin" />
						) : (
							<FiZap size={16} fill={book?.is_spotlighted ? "currentColor" : "none"} />
						)}
					</button>
				</div>
			)}
		</div>
	);
};

export default BookActionsColumn;
